// react library imports
import { CaretDown } from 'phosphor-react';
import { useState, useEffect } from 'react';

// style imports
import './MobileInputField.css';

// import assets
import indianFlag from '../../../Assets/Image/indianFlag.png'

const MobileInputField = ({mobileNumber, onChange, readOnly, id}) => {
  // Use state to manage the input value
  const [value, setValue] = useState('');

  useEffect(()=>{
    if (mobileNumber) {
      setValue(mobileNumber)
    }
  }, [mobileNumber])  

  // handle onchange event of mobile number
  const handleOnchange=(e)=>{
    // Limiting the input to 10 digits
    const value = e.target.value.replace(/\D/g, '').slice(0, 10);
    setValue(value)
    if (onChange) {
      onChange(value)
    }
  }
  return (
    <div className='mobile_input_field_container
    mues_row_space_between'>
        <div className='mues_row_flex mues_grey_I
        mobile_input_field_head mues_column_gap_8'>
            <img src={indianFlag} alt='indian_flag'/>
            <p className='mues_font_weight_600'>+91</p>
            <CaretDown className='mues_wrapper_icon'
            weight='bold'/>
        </div>
        <input className='mobile_input_field mues_font_weight_600 mues_grey_I'
        placeholder='Enter the Mobile Number' value={value} pattern='[0-9]{10}'
        maxLength={10} readOnly={readOnly} onChange={handleOnchange} id={id}/>
    </div>
  )
}

export default MobileInputField